import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { IngredientsData, RecipeDetailsData } from "~/interface/recipe/recipe";
import { MstPersonType } from "~/type";
import API_PATH from "~/utils/api-routes";
import api from "~/utils/Interceptor";

interface InitialStateData {
  recipeCategories: MstPersonType[];
  isRecipeDialogOpen: boolean;
  ingredientsData: IngredientsData | null;
  selectedRecipeCategory: string | null;
}

const initialState: InitialStateData = {
  recipeCategories: [],
  isRecipeDialogOpen: false,
  ingredientsData: null,
  selectedRecipeCategory: null,
};

export const getRecipeIngredientsThunk = createAsyncThunk("recipe/ingredients", async (id: string, { rejectWithValue }) => {
  try {
    const response = await api.get(`${API_PATH.RECIPE_INGREDIENTS}/${id}`);
    return response.data.data;
  } catch (error) {
    const err = error as AxiosError<{ message: string }>;
    const message = err.response?.data?.message || err.message || "Unknown error";
    return rejectWithValue(message);
  }
});

const recipeSlice = createSlice({
  name: "recipe",
  initialState,
  reducers: {
    setRecipeCategories: (state, action: PayloadAction<MstPersonType[]>) => {
      state.recipeCategories = action.payload;
    },
    setIsRecipeDialogOpenTrue: (state) => {
      state.isRecipeDialogOpen = true;
    },
    setIsRecipeDialogOpenFalse: (state) => {
      state.isRecipeDialogOpen = false;
    },
    setSelectedRecipeCategory: (state, action: PayloadAction<string>) => {
      state.selectedRecipeCategory = action.payload;
    },
    setIngredientsData: (state, action: PayloadAction<IngredientsData | null>) => {
      state.ingredientsData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRecipeIngredientsThunk.pending, (state) => {
        state.ingredientsData = null;
      })
      .addCase(getRecipeIngredientsThunk.fulfilled, (state, action: PayloadAction<IngredientsData>) => {
        state.ingredientsData = action.payload;
        state.isRecipeDialogOpen = true;
      })
      .addCase(getRecipeIngredientsThunk.rejected, (state, action: PayloadAction<any>) => {
        state.ingredientsData = null;
      });
  },
});

export const { setRecipeCategories, setIsRecipeDialogOpenTrue, setIsRecipeDialogOpenFalse, setSelectedRecipeCategory, setIngredientsData } =
  recipeSlice.actions;

export default recipeSlice.reducer;
